import { render } from "./PlayerHand.vue?vue&type=template&id=36944b9d"
import script from "./PlayerHand.vue?vue&type=script&lang=js"
export * from "./PlayerHand.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__